import { render } from "./AdminFamilyManagement.vue?vue&type=template&id=df561f14&scoped=true"
import script from "./AdminFamilyManagement.vue?vue&type=script&lang=js"
export * from "./AdminFamilyManagement.vue?vue&type=script&lang=js"

import "./AdminFamilyManagement.vue?vue&type=style&index=0&id=df561f14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df561f14"]])

export default __exports__